import {NoteChangePriceFormField} from "../types/note-change-price.types";
import {Validators} from "@angular/forms";

export const noteChangePriceBaseFields: Array<NoteChangePriceFormField> = [
  {
    fieldName: 'customerPriceBefore',
    label: 'Цена для клиента до',
    shortLabel: 'до',
    type: 'number',
    rowKey: 'customerPrice',
    validators: [Validators.required]
  },
  {
    fieldName: 'customerPriceAfter',
    label: 'Цена для клиента после',
    shortLabel: 'после',
    type: 'number',
    rowKey: 'customerPrice',
    validators: [Validators.required]
  },
  {
    fieldName: 'sppBefore',
    label: 'СПП до',
    shortLabel: 'до',
    type: 'number',
    rowKey: 'spp',
    needMatTextSuffix: true,
    matTextSuffix: '%',
    validators: [Validators.required]
  },
  {
    fieldName: 'sppAfter',
    label: 'СПП после',
    shortLabel: 'после',
    type: 'number',
    rowKey: 'spp',
    needMatTextSuffix: true,
    matTextSuffix: '%',
    validators: [Validators.required]
  },
  {
    fieldName: 'marketplacePriceBefore',
    label: 'Цена на маркетплейсе до',
    shortLabel: 'до',
    type: 'number',
    rowKey: 'marketplacePrice',
    validators: [Validators.required]
  },
  {
    fieldName: 'marketplacePriceAfter',
    label: 'Цена на маркетплейсе после',
    shortLabel: 'после',
    type: 'number',
    rowKey: 'marketplacePrice',
    validators: [Validators.required]
  },
  {
    fieldName: 'unitProfitBefore',
    label: 'Прибыль на еденицу до',
    shortLabel: 'до',
    type: 'number',
    rowKey: 'unitProfit',
    validators: [Validators.required]
  },
  {
    fieldName: 'unitProfitAfter',
    label: 'Прибыль на еденицу после',
    shortLabel: 'после',
    type: 'number',
    rowKey: 'unitProfit',
    validators: [Validators.required]
  },
  {
    fieldName: 'cpoBefore',
    label: 'CPO до',
    shortLabel: 'до',
    type: 'number',
    rowKey: 'cpo',
    validators: [Validators.required]
  },
  {
    fieldName: 'cpoAfter',
    label: 'CPO после',
    shortLabel: 'после',
    type: 'number',
    rowKey: 'cpo',
    validators: [Validators.required]
  },
  {
    fieldName: 'salesQuantityBefore',
    label: 'Количество продаж до',
    shortLabel: 'до',
    type: 'number',
    rowKey: 'salesQuantity',
    validators: [Validators.required]
  },
  {
    fieldName: 'salesQuantityAfter',
    label: 'Количество продаж после',
    shortLabel: 'после',
    type: 'number',
    rowKey: 'salesQuantity',
    validators: [Validators.required]
  },
  {
    fieldName: 'advertisementBudget',
    label: 'Рекламный бюджет',
    type: 'number',
    rowKey: 'advertisementBudget'
  },
  {
    fieldName: 'comment',
    label: 'Комментарий',
    type: 'textarea',
    rowKey: 'comment'
  }
]

export const noteChangePriceCreateFields: Array<NoteChangePriceFormField> = [
  ...noteChangePriceBaseFields
]

export const noteChangePriceEditFields: Array<NoteChangePriceFormField> = [
  {
    fieldName: 'advertisementsExpensesShareBefore',
    label: 'ДРР до',
    shortLabel: 'до',
    type: 'number',
    rowKey: 'advertisementsExpensesShare',
    needMatTextSuffix: true,
    matTextSuffix: '%',
    noEdit: true
  },
  {
    fieldName: 'advertisementsExpensesShareAfter',
    label: 'ДРР после',
    shortLabel: 'после',
    type: 'number',
    rowKey: 'advertisementsExpensesShare',
    needMatTextSuffix: true,
    matTextSuffix: '%',
    noEdit: true
  },
  {
    fieldName: 'revenueBefore',
    label: 'Выручка до',
    shortLabel: 'до',
    type: 'number',
    rowKey: 'revenue',
    noEdit: true
  },
  {
    fieldName: 'revenueAfter',
    label: 'Выручка после',
    shortLabel: 'после',
    type: 'number',
    rowKey: 'revenue',
    noEdit: true
  },
  {
    fieldName: 'profitBefore',
    label: 'Прибыль до',
    shortLabel: 'до',
    type: 'number',
    rowKey: 'profit',
    noEdit: true
  },
  {
    fieldName: 'profitAfter',
    label: 'Прибыль после',
    shortLabel: 'после',
    type: 'number',
    rowKey: 'profit',
    noEdit: true
  },
  ...noteChangePriceBaseFields
]
